import { QueryClient } from '@tanstack/react-query';

// The app's one React Query client. Screens that use it also keep Firestore
// listeners for their live data, so refetching on every window focus would
// only add reads.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
